import React from 'react';
import { Typography, Grid } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import theme from '../../theme';

const NoData = ({ message = '게시물 없음', paddingTop = '100px' }) => {
  return (
    <Grid item xs={12} py={paddingTop}>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Typography align="center" fontSize={16} color={theme.palette.black[2]}>
        {message}
      </Typography>
    </Grid>
  );
};

export default NoData;
